var React = require('react');

function Bars (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m0 0h30v30h-30z","fill":"none","key":0}),React.createElement("path",{"d":"m20 20h-5v-13.75h5zm-7.5 0h-5v-20h5zm-7.5 0h-5v-10h5z","fill":"#04968b","transform":"translate(5 5)","key":1})]);
}

Bars.defaultProps = {"height":"30","viewBox":"0 0 30 30","width":"30"};

module.exports = Bars;

Bars.default = Bars;
